import React from 'react'

function BodyHeader({channelName}) {
  return (
    <div className=" shadow-md mb-5 text-2xl font-serif font-extrabold   p-4">
        
       
            <h1 >{ channelName }</h1>

        
        
        
        
    </div>
  )
}

export default BodyHeader